import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import FotterMain from '../BaseComponents/FotterMain'
import Header from '../BaseComponents/Header'

const BatteryOperatedHandTool = () => {
    const toTop = () => {
        window.scrollTo(0, 0);
    }
    useEffect(() => {
        toTop();
    }, []);
    return (
        <>
            <Helmet>
                <title>Battery Operated Hand Tools</title>
            </Helmet>
            <Header />
            <div className='innerpagebg pt-5 pb-5'>
                <div className='container mb-4'>
                    <div className='row'>
                        <div className='col-12  m-auto'>
                            <div className="align-items-center text-left">
                                <h4 className='d-inline-block m-0 fw-bold'>
                                    <span className='txtred'>Battery</span><span className='txtdgray'> Operated Hand Tools</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row '>
                        <div className='col-lg-12 col-mg-12 col-sm-12 col-12 text-start m-auto'>
                            <div className='card p-3 rounded-0 shadow-sm pt-3'>
                                <div className='f18 mb-2'><strong>Battery and Charger Manufactured by and Marketed by Information</strong></div>

                                <ul className='pt-3'>
                                    <li className=''>
                                        <p>
                                            <strong>Manufactured by</strong>
                                        </p>
                                        <p className='mb-0'>
                                            <strong>Zhejiang YAT Electrical Appliance Co., Ltd.</strong>
                                        </p>
                                        <p>
                                            NO.150 WENLONG ROAD, YUXIN TOWN, NANHU DISTRICT, JIAXING CITY, ZHEJIANG PROVINCE, CHINA, 314009</p>
                                    </li>
                                    <li className=''>
                                        <p>
                                            <strong>Imported & marketed by</strong>
                                        </p>
                                        <p className='mb-0'>
                                            <strong>Honda India Power Products Limited</strong>, Head Office & Works:
                                        </p>
                                        <p>
                                            Plot No. 5, Sector-41 (Kasna), Greater Noida Industrial Development Area, District Gautam Budh Nagar, Uttar Pradesh – 201310, India<br />Registered Office: 409, DLF Tower-B, Jasola Commercial Complex, New Delhi – 110025, India
                                        </p>
                                    </li>
                                    <li className=''>
                                        <p>
                                            <strong>Customer Care</strong>
                                        </p>

                                        <p>
                                            Head Service, Honda India Power Products Limited,
                                            Plot No. 5, Sector-41 (Kasna), Greater Noida Industrial Development Area,<br />Distt. Gautam Budh Nagar, Uttar Pradesh-201310 Ph.No. 0120-259 0327, Toll Free 1800-11-2323,<br /> Email: <a href="mailto:ho.service@hipp.co.in">ho.service@hipp.co.in</a>
                                        </p>
                                    </li>
                                    <li className=''>
                                        <p>
                                            <strong>Country of Origin</strong> China
                                        </p>

                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FotterMain />

        </>
    )
}

export default BatteryOperatedHandTool